export function copyData(copyText) {
    const textArea = document.createElement('textarea');
    textArea.value = copyText;
    document.body.appendChild(textArea);
    textArea.select();
    textArea.style.position = 'fixed';
    textArea.style.top = '-9999px';
    textArea.style.left = '-9999px';
    document.execCommand('copy');
    textArea.blur();
}
//# sourceMappingURL=utils.js.map